import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import PbxContext from '../../../context/PbxContext';

import TrunksIp from './components/TrunksIp';
import TrunksAuth from './components/TrunksAuth';
import TrunksInboundDispatcher from './TrunksInboundDispatcher';

import { accessLocalStorage, exportCreateTrunks, valuesAnalyze, changeViewForms, readAllTenant, sendReloadAsteriskSystem, createInboundDispatcherTrunk } from '../../../services';

import Loading from '../../Loading/LoadingModule';

import '../../../libs/bulma.min.css';
import './TrunksForm.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare, faPhoneSquareAlt, faPhone, faSave, faArrowLeft } from '@fortawesome/free-solid-svg-icons';

function TrunksCreate() {
  const getItensStateGlobal = useContext(PbxContext);
  const { majoritaryItemsEndpoints, toggleIsHidden, toggleIsChangeFormElements } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const history = useHistory();

  const [values, setValues] = useState({
    "ipLocal": "",
    "trunkNumber": "",
    "authUsername": "",
    "password": "",
    "tenant": "",
    "realNumber": "",
  });
  const [validate, setValidate] = useState({});
  const [disable, setDisable] = useState(true);
  const [tenants, setTenants] = useState([]);
  const [selectedType, setSelectedType] = useState('');
  const [isVgsMaster, setIsVgsMaster] = useState(false);
  const [inboundState, setInboundState] = useState({ valid: false });

  const { changeBorderImputToRedOrNormal, changeVisibityMessages} = changeViewForms;

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role, idtenant } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');
    let fetchTenants = await readAllTenant();
    if (!fetchTenants) return;
    if (!idtenant.includes('vgs')) fetchTenants = fetchTenants.filter((tenant) => tenant.short_name === idtenant);
    setTenants(fetchTenants);
    // Controle estrito para liberar o modo "Inbound Dispatcher (VGS)".
    setIsVgsMaster(idtenant === 'vgs' && role === 'root');
  }, []);

  const changeScreen = (check, name) => {
    changeBorderImputToRedOrNormal(check, name);
    changeVisibityMessages(check, `${name}-invalid-data`);
  };

  const handleChangeDataAnalyze = (name, value) => {
    const { checkNumber, checkPassword, isTripleChar, isIP } = valuesAnalyze;

    if(name === 'trunkNumber') {
      const checkValueIsNumber = checkNumber(value);
      changeScreen(checkValueIsNumber, name);
      return checkValueIsNumber;
    };

    if(name === 'password') {
      const passwordIsValid = value.length > 5 ? true : false;
      changeScreen(passwordIsValid, name);
      return passwordIsValid;
      // return true;
    }

    if(name === 'mode') {
      const modeAnalyze = value === 'bidirecional' || value === 'unidirecional' ? true : false;
      
      // Mostrar/esconder campo realNumber baseado no modo selecionado
      const realNumberFieldIP = document.getElementById('realNumber-field');
      const realNumberFieldAuth = document.getElementById('realNumber-field-auth');
      
      if (value === 'unidirecional') {
        if (realNumberFieldIP) realNumberFieldIP.style.display = 'flex';
        if (realNumberFieldAuth) realNumberFieldAuth.style.display = 'flex';
      } else {
        if (realNumberFieldIP) realNumberFieldIP.style.display = 'none';
        if (realNumberFieldAuth) realNumberFieldAuth.style.display = 'none';
        // Limpar o valor se não for unidirecional
        setValues((prevState) => ({...prevState, realNumber: ''}));
      }
      
      return modeAnalyze;
    }

    if(name === 'realNumber') {
      const realNumberIsValid = value.length >= 10 ? true : false;
      changeScreen(realNumberIsValid, name);
      return realNumberIsValid;
    }

    if(name === 'provider' || name === 'authUsername') {
      const checkValueIsCharacters = isTripleChar(value);
      changeScreen(checkValueIsCharacters, name);
      return checkValueIsCharacters;
    }

    if(name === 'ipSbcTrunk'|| name === 'ipLocal') {
      const checkValueIsCharacters = true;
      // const checkValueIsCharacters = isIP(value);
      // changeScreen(checkValueIsCharacters, name);
      return checkValueIsCharacters;
    }
  };

  const handleChangeCodec = (name, value) => {
    let prevSetValueCodec = values[name];

    if (!values.hasOwnProperty('codec')) prevSetValueCodec = [];
    prevSetValueCodec = prevSetValueCodec.includes(value) ? prevSetValueCodec.filter((codec) => codec !== value) : [...prevSetValueCodec, value];
    prevSetValueCodec.toString();

    setValues((prevState) => prevState, values[name] = prevSetValueCodec);
  };

  const handleChangeValues = (item) => {
    const { name, value } = item;

    // Canal especial usado pelo TrunksInboundDispatcher para empurrar seu
    // estado consolidado (provider, CSV de IPs, ipLocal, codec, valid).
    if (name === '__inboundDispatcherState') {
      setInboundState(value);
      setDisable(!value.valid);
      return;
    }

    const itemStatus = handleChangeDataAnalyze(name, value);
    if (name === 'codec') handleChangeCodec(name, value);
    setValidate((prevState) => prevState, validate[name] = itemStatus === undefined  ? true : itemStatus);
    if (name !== 'codec') setValues((prevState) => prevState, values[name] = value );
    if(Object.keys(validate).length >= 8) Object.values(validate).includes(false) ? setDisable(true) : setDisable(false);
    return;
  };

  const typeTrunkSelected = (item) => {
    const { value } = item;
    setSelectedType(value);
    if (value === 'IP') {
      changeVisibityMessages(true, 'trunk-auth-div');
      changeVisibityMessages(true, 'trunk-inboundd-div');
      changeVisibityMessages(false, 'trunk-ip-div');
      changeVisibityMessages(false, 'button-send-form');
      handleChangeValues(item);
      return;
    }
    if (value === 'InboundDispatcher') {
      changeVisibityMessages(true, 'trunk-ip-div');
      changeVisibityMessages(true, 'trunk-auth-div');
      changeVisibityMessages(false, 'trunk-inboundd-div');
      changeVisibityMessages(false, 'button-send-form');
      handleChangeValues(item);
      return;
    }

    changeVisibityMessages(true, 'trunk-ip-div');
    changeVisibityMessages(true, 'trunk-inboundd-div');
    changeVisibityMessages(false, 'trunk-auth-div');
    changeVisibityMessages(false, 'button-send-form');
    handleChangeValues(item);
    return;
  };

  const sendDataTrunkGenerate = async () => {
    // Fluxo dedicado para troncos inbound-dispatcher (master VGS).
    if (selectedType === 'InboundDispatcher') {
      if (!inboundState.valid) {
        return changeVisibityMessages(false, 'nosuccess-create-trunks');
      }
      const resp = await createInboundDispatcherTrunk({
        provider: inboundState.provider,
        ipsMatch: inboundState.ipsMatch,
        ipLocal: inboundState.ipLocal,
        codec: inboundState.codec,
      });
      if (resp.status === 201) {
        toggleIsChangeFormElements('trunk-all-form', 'is-hidden');
        changeVisibityMessages(false, 'success-create-trunks');
        setTimeout(() => history.push('/config/tronco/lista'), 3000);
        return;
      }
      return changeVisibityMessages(false, 'nosuccess-create-trunks');
    }

    const fetchTrunks = await exportCreateTrunks(values);
    const result = Object.keys(fetchTrunks).length > 0 ? true : false;
    const reloadPjsip = await sendReloadAsteriskSystem({ command: 'asterisk' });

    if(result) {
      toggleIsChangeFormElements('trunk-all-form', 'is-hidden');
      changeVisibityMessages(false, 'success-create-trunks');
      setTimeout(() => {
        return history.push('/config/tronco/lista');
      }, 3000);
    } else {
      return changeVisibityMessages(false, 'nosuccess-create-trunks');
    }
  };

  useEffect(() => {
    validateUserLogged();
  }, [validateUserLogged]);

  return (
    <div className="trunks-form-container">
      <div className="trunks-form-header">
        <div className="trunks-form-title-wrapper">
          <svg className="trunks-form-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
          </svg>
          <div>
            <h1 className="trunks-form-title">Adicionar Tronco</h1>
            <p className="trunks-form-subtitle">Configure um novo tronco SIP (IP ou Autenticado)</p>
          </div>
        </div>
        <Link to="/config/tronco/lista" className="btn-back">
          <FontAwesomeIcon icon={faArrowLeft} />
          Voltar
        </Link>
      </div>

      <div className="alerts-section">
        <div id="nosuccess-create-trunks" className="alert-message alert-danger is-hidden">
          <div className="alert-header">
            <span>Erro!</span>
            <button className="alert-close" aria-label="delete" onClick={() => toggleIsHidden('#nosuccess-create-trunks')}>×</button>
          </div>
          <div className="alert-body">
            <strong>Não foi possível criar o tronco!</strong><br />
            <strong>Já existe</strong> um tronco com esse nome!
          </div>
        </div>

        <div id="success-create-trunks" className="alert-message alert-success is-hidden">
          <div className="alert-header">
            <span>Sucesso!</span>
            <button className="alert-close" aria-label="delete" onClick={() => toggleIsHidden('#success-create-trunks')}>×</button>
          </div>
          <div className="alert-body">
            Tronco criado com <strong>sucesso</strong>!
          </div>
        </div>
      </div>

      <div id="trunk-all-form" className="trunk-type-card">
        <p className="trunk-type-title">Tipo de Tronco</p>
        <div className="trunk-type-options">
          <div className="trunk-type-option">
            <input type="radio" id="type-auth" name="type" value="Auth" onChange={(e) => typeTrunkSelected(e.target)} />
            <label htmlFor="type-auth">Autenticado</label>
          </div>
          <div className="trunk-type-option">
            <input type="radio" id="type-ip" name="type" value="IP" onChange={(e) => typeTrunkSelected(e.target)} />
            <label htmlFor="type-ip">IP</label>
          </div>
          {isVgsMaster && (
            <div className="trunk-type-option">
              <input type="radio" id="type-inboundd" name="type" value="InboundDispatcher" onChange={(e) => typeTrunkSelected(e.target)} />
              <label htmlFor="type-inboundd">Inbound Dispatcher (VGS)</label>
            </div>
          )}
        </div>
        <p name="type-invalid-data" className="form-error is-hidden">Selecione o tipo de tronco!</p>
      </div>

      <div name="trunk-ip-div" className="is-hidden">
        <div className="form-card">
          <TrunksIp changeValues={handleChangeValues} tenants={tenants} />
        </div>
      </div>

      <div name="trunk-auth-div" className="is-hidden">
        <div className="form-card">
          <TrunksAuth changeValues={handleChangeValues} tenants={tenants} />
        </div>
      </div>

      {isVgsMaster && (
        <div name="trunk-inboundd-div" className="is-hidden">
          <div className="form-card">
            <TrunksInboundDispatcher changeValues={handleChangeValues} />
          </div>
        </div>
      )}

      <div name="button-send-form" className="is-hidden">
        <div className="form-actions">
          <Link to="/config/tronco/lista" className="btn-cancel">
            <FontAwesomeIcon icon={faArrowLeft} />
            Cancelar
          </Link>
          <button className="btn-submit" type="submit" disabled={disable} onClick={() => sendDataTrunkGenerate()}>
            <FontAwesomeIcon icon={faSave} />
            <span>Criar Tronco</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default TrunksCreate;
